const getters = {

    mindControlledUser: (state) => state.mindControlledUser,
}

export default getters